import { useMutation, useQueryCache } from 'react-query';
import { removeAssistants } from 'src/services/api/users';

function useRemoveAssistants() {
  const queryCache = useQueryCache();

  return useMutation(({ user, data }) => removeAssistants(user, data), {
    onSuccess: (data) => queryCache.setQueryData(['user', data.data?.id], data),
  });
}

export default useRemoveAssistants;
